import axios from 'axios';

const resolveDefaultBase = (): string => {
  if (typeof window === 'undefined') {
    return 'https://api.expenses.firstgrowthventures.com';
  }

  const host = window.location.hostname;

  if (host === 'localhost' || host === '127.0.0.1') {
    // Use environment variable for local dev, default to 4000 (local backend default port)
    return `http://localhost:${process.env.REACT_APP_LOCAL_PORT || '4000'}`;
  }

  if (
    host === 'staging.expenses.firstgrowthventures.com' ||
    host === 'api.staging.expenses.firstgrowthventures.com'
  ) {
    return 'https://api.staging.expenses.firstgrowthventures.com';
  }

  if (
    host === 'expenses.firstgrowthventures.com' ||
    host === 'api.expenses.firstgrowthventures.com'
  ) {
    return 'https://api.expenses.firstgrowthventures.com';
  }

  return 'https://api.expenses.firstgrowthventures.com';
};

// Base URL comes from build-time env; fallback to resolved runtime default
export const API_BASE = process.env.REACT_APP_API_BASE || resolveDefaultBase();

// Shared axios instance
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false, // not using cookie-based auth; avoid CORS credentials requirement
});


/**
 * Helper function to generate absolute URLs for files (uploads/reports)
 * Handles different environments and ensures proper URL construction
 */
export const fileUrl = (path: string): string => {
  if (!path) return '';

  const normalizeBase = (base: string) => (base.endsWith('/') ? base : `${base}/`);
  const stripLeadingSlash = (value: string) => (value.startsWith('/') ? value.substring(1) : value);

  if (path.startsWith('http')) {
    try {
      const url = new URL(path);

      if (
        typeof window !== 'undefined' &&
        window.location.hostname === 'expenses.firstgrowthventures.com' &&
        (url.hostname === 'staging.expenses.firstgrowthventures.com' ||
          url.hostname === 'api.staging.expenses.firstgrowthventures.com')
      ) {
        const cleanedStagingPath = stripLeadingSlash(url.pathname);
        return `${normalizeBase('https://api.expenses.firstgrowthventures.com')}${cleanedStagingPath}`;
      }

      return path;
    } catch (_error) {
      return path;
    }
  }

  const cleanPath = stripLeadingSlash(path);

  // Special handling for Firebase hosting
  if (typeof window !== 'undefined') {
    const host = window.location.host;
    if (host.includes('web.app') || host.includes('firebaseapp.com')) {
      const apiDomain = host.includes('staging')
        ? 'https://api.staging.expenses.firstgrowthventures.com'
        : 'https://api.expenses.firstgrowthventures.com';
      return `${normalizeBase(apiDomain)}${cleanPath}`;
    }
  }

  // For staging, serve from same origin to avoid CORS/CSP issues with iframes
  if (typeof window !== 'undefined' && window.location.hostname.includes('staging')) {
    return `${normalizeBase(window.location.origin)}${cleanPath}`;
  }
  
  // Default: serve from the API base URL
  return `${normalizeBase(API_BASE)}${cleanPath}`;
};
